module.exports = __webpack_public_path__ + "static/banner-two-shape2-74722488773d63d9593ad0468f431bb5.png";